// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BannerSettingsForm-space1-Wq0FW {
	margin-bottom: 6px !important;
}

.BannerSettingsForm-space2-gbOCs {
	margin-bottom: 12px !important;
}

.BannerSettingsForm-space3-qYLJ8 {
	margin-bottom: 18px !important;
}

.BannerSettingsForm-space4-HIpco {
	margin-bottom: 24px !important;
}

.BannerSettingsForm-space5-fIw6X {
	margin-bottom: 30px !important;
}

.BannerSettingsForm-space6-FSwhl {
	margin-bottom: 36px !important;
}

.BannerSettingsForm-space7-mFhT5 {
	margin-bottom: 42px !important;
}

.BannerSettingsForm-space8-kREjX {
	margin-bottom: 48px !important;
}

.BannerSettingsForm-spaceTop1-ShUJP {
	margin-top: 6px !important;
}

.BannerSettingsForm-spaceTop2-Ua0SI {
	margin-top: 12px !important;
}

.BannerSettingsForm-spaceTop3-f9O4F {
	margin-top: 18px !important;
}

.BannerSettingsForm-spaceTop4-wBATp {
	margin-top: 24px !important;
}

.BannerSettingsForm-spaceTop5-cFABs {
	margin-top: 30px !important;
}

.BannerSettingsForm-spaceTop6-nubvF {
	margin-top: 36px !important;
}

.BannerSettingsForm-spaceTop7-_iX3a {
	margin-top: 42px !important;
}

.BannerSettingsForm-spaceTop8-TFrqd {
	margin-top: 48px !important;
}

.BannerSettingsForm-noMargin-Ewcwa {
	margin: 0px !important;
}

.BannerSettingsForm-padding1-T1OUO {
	padding-bottom: 6px !important;
}

.BannerSettingsForm-padding2-GnNNH {
	padding-bottom: 12px !important;
}

.BannerSettingsForm-padding3-ugrzX {
	padding-bottom: 18px !important;
}

.BannerSettingsForm-padding4-rxm2s {
	padding-bottom: 24px !important;
}

.BannerSettingsForm-padding5-YOynR {
	padding-bottom: 30px !important;
}

.BannerSettingsForm-padding6-HIjBA {
	padding-bottom: 36px !important;
}

.BannerSettingsForm-padding7-LQwbZ {
	padding-bottom: 42px !important;
}

.BannerSettingsForm-paddingTop1-BWMNp {
	padding-top: 6px !important;
}

.BannerSettingsForm-paddingTop2-tsTyi {
	padding-top: 12px !important;
}

.BannerSettingsForm-paddingTop3-WPH0x {
	padding-top: 18px !important;
}

.BannerSettingsForm-paddingTop4-TPnfz {
	padding-top: 24px !important;
}

.BannerSettingsForm-paddingTop5-c445D {
	padding-top: 30px !important;
}

.BannerSettingsForm-paddingTop6-oIK53 {
	padding-top: 36px !important;
}

.BannerSettingsForm-paddingTop7-YRvMl {
	padding-top: 42px !important;
}

.BannerSettingsForm-noPadding-JAc2X {
	padding: 0px !important;
}

.BannerSettingsForm-spaceMarginBottom0-uXhn0 {
	margin-bottom: 0;
}

.BannerSettingsForm-textBold-mGuu3 {
	font-weight: 500 !important;
}

.BannerSettingsForm-textBolder-gOxGF {
	font-weight: 700 !important;
}

.BannerSettingsForm-textNormal-zDXYD {
	font-weight: normal !important;
}

/*New Design Text Colors */

.BannerSettingsForm-textDarkBlue-J_GYf {
	color: rgb(20, 39, 94) !important;
}

.BannerSettingsForm-textLightBlue-BZdkL {
	color: rgb(57, 87, 106) !important;
}

.BannerSettingsForm-textLightSandleGreen-iwWk2 {
	color: rgb(76, 86, 41) !important;
}

.BannerSettingsForm-textLightBrown-cEDGU {
	color: rgb(115, 79, 33) !important;
}

.BannerSettingsForm-textMediumMaroon-tStr8 {
	color: rgb(87, 37, 51) !important;
}

.BannerSettingsForm-textBrown-gzcd4 {
	color: rgb(160, 47, 24) !important;
}

.BannerSettingsForm-textMaroon-zRjSD {
	color: rgb(155, 49, 67) !important;
}

.BannerSettingsForm-textDarkBrown-UZGA2 {
	color: rgb(83, 18, 16) !important;
}

.BannerSettingsForm-textMediumBrown-i0SbT {
	color: rgb(142, 28, 10) !important;
}

.BannerSettingsForm-textSkyBlue-f1TXw {
	color: rgb(37, 117, 141) !important;
}

.BannerSettingsForm-textGray-WocVL {
	color: rgb(77, 65, 51) !important;
}

.BannerSettingsForm-errorMessage-Gsbew {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.BannerSettingsForm-userText-tFUmA {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.BannerSettingsForm-panelHeader-klgQ1 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.BannerSettingsForm-exportSection-_j695 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.BannerSettingsForm-exportSectionGridSub-qcYQr {
	grid-template-columns: 50% 49% !important;
}

.BannerSettingsForm-exportText-kjz_0 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.BannerSettingsForm-exportLinkImg-cAwpD {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.BannerSettingsForm-exportImg-iohfj {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.BannerSettingsForm-linkBtn-Kw1jq {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.BannerSettingsForm-table-xC8gL {
	display: table;
}

.BannerSettingsForm-tableRow-mrKyj {
	display: table-row;
}

.BannerSettingsForm-tableCell-t4BrN {
	display: table-cell;
	float: none;
}

.BannerSettingsForm-formGroup-yrOBV {
	margin-bottom: 6px;
}

.BannerSettingsForm-marginTop0-KAYRl {
	margin-top: 0;
}

.BannerSettingsForm-marginBottom20-uDhZR {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.BannerSettingsForm-bannerImageBg-Kf7wA {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.BannerSettingsForm-bannerDelete-LBxwd {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.BannerSettingsForm-exportLink-jANOr {
	padding-top: 10px;
	padding-right: 10px;
}

.BannerSettingsForm-seachContent-Av1HO {
	padding-left: 0px;
	margin-bottom: 5px;
}

.BannerSettingsForm-marginBottom9-f5iRm {
	margin-bottom: 9px;
}

.BannerSettingsForm-spaceTop52-QjFfm {
	margin-top: 52px;
}

.BannerSettingsForm-profileViewInner-KNW5v {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.BannerSettingsForm-profileViewMain-GGLoA {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.BannerSettingsForm-profileViewlabel-vMdGa {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.BannerSettingsForm-profileViewMainContent-BtwS0 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.BannerSettingsForm-reviewsFormStar-Jw0ko {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.BannerSettingsForm-reviewsFormStar-Jw0ko svg {
	cursor: pointer;
}

.BannerSettingsForm-addLanguageText-c0VIP {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.BannerSettingsForm-exportSection-_j695 {
		grid-template-columns: 100%;
	}

	.BannerSettingsForm-spaceTop52-QjFfm {
		margin-top: 18px;
	}

	.BannerSettingsForm-exportText-kjz_0 {
		float: none;
		margin-top: 12px;
	}

	.BannerSettingsForm-exportSectionGridSub-qcYQr {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.BannerSettingsForm-profileViewlabel-vMdGa {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.BannerSettingsForm-profileViewMainContent-BtwS0 {
		width: 100%;
		text-align: center;
	}

	.BannerSettingsForm-panelHeader-klgQ1 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `BannerSettingsForm-space1-Wq0FW`,
	"space2": `BannerSettingsForm-space2-gbOCs`,
	"space3": `BannerSettingsForm-space3-qYLJ8`,
	"space4": `BannerSettingsForm-space4-HIpco`,
	"space5": `BannerSettingsForm-space5-fIw6X`,
	"space6": `BannerSettingsForm-space6-FSwhl`,
	"space7": `BannerSettingsForm-space7-mFhT5`,
	"space8": `BannerSettingsForm-space8-kREjX`,
	"spaceTop1": `BannerSettingsForm-spaceTop1-ShUJP`,
	"spaceTop2": `BannerSettingsForm-spaceTop2-Ua0SI`,
	"spaceTop3": `BannerSettingsForm-spaceTop3-f9O4F`,
	"spaceTop4": `BannerSettingsForm-spaceTop4-wBATp`,
	"spaceTop5": `BannerSettingsForm-spaceTop5-cFABs`,
	"spaceTop6": `BannerSettingsForm-spaceTop6-nubvF`,
	"spaceTop7": `BannerSettingsForm-spaceTop7-_iX3a`,
	"spaceTop8": `BannerSettingsForm-spaceTop8-TFrqd`,
	"noMargin": `BannerSettingsForm-noMargin-Ewcwa`,
	"padding1": `BannerSettingsForm-padding1-T1OUO`,
	"padding2": `BannerSettingsForm-padding2-GnNNH`,
	"padding3": `BannerSettingsForm-padding3-ugrzX`,
	"padding4": `BannerSettingsForm-padding4-rxm2s`,
	"padding5": `BannerSettingsForm-padding5-YOynR`,
	"padding6": `BannerSettingsForm-padding6-HIjBA`,
	"padding7": `BannerSettingsForm-padding7-LQwbZ`,
	"paddingTop1": `BannerSettingsForm-paddingTop1-BWMNp`,
	"paddingTop2": `BannerSettingsForm-paddingTop2-tsTyi`,
	"paddingTop3": `BannerSettingsForm-paddingTop3-WPH0x`,
	"paddingTop4": `BannerSettingsForm-paddingTop4-TPnfz`,
	"paddingTop5": `BannerSettingsForm-paddingTop5-c445D`,
	"paddingTop6": `BannerSettingsForm-paddingTop6-oIK53`,
	"paddingTop7": `BannerSettingsForm-paddingTop7-YRvMl`,
	"noPadding": `BannerSettingsForm-noPadding-JAc2X`,
	"spaceMarginBottom0": `BannerSettingsForm-spaceMarginBottom0-uXhn0`,
	"textBold": `BannerSettingsForm-textBold-mGuu3`,
	"textBolder": `BannerSettingsForm-textBolder-gOxGF`,
	"textNormal": `BannerSettingsForm-textNormal-zDXYD`,
	"textDarkBlue": `BannerSettingsForm-textDarkBlue-J_GYf`,
	"textLightBlue": `BannerSettingsForm-textLightBlue-BZdkL`,
	"textLightSandleGreen": `BannerSettingsForm-textLightSandleGreen-iwWk2`,
	"textLightBrown": `BannerSettingsForm-textLightBrown-cEDGU`,
	"textMediumMaroon": `BannerSettingsForm-textMediumMaroon-tStr8`,
	"textBrown": `BannerSettingsForm-textBrown-gzcd4`,
	"textMaroon": `BannerSettingsForm-textMaroon-zRjSD`,
	"textDarkBrown": `BannerSettingsForm-textDarkBrown-UZGA2`,
	"textMediumBrown": `BannerSettingsForm-textMediumBrown-i0SbT`,
	"textSkyBlue": `BannerSettingsForm-textSkyBlue-f1TXw`,
	"textGray": `BannerSettingsForm-textGray-WocVL`,
	"errorMessage": `BannerSettingsForm-errorMessage-Gsbew`,
	"userText": `BannerSettingsForm-userText-tFUmA`,
	"panelHeader": `BannerSettingsForm-panelHeader-klgQ1`,
	"exportSection": `BannerSettingsForm-exportSection-_j695`,
	"exportSectionGridSub": `BannerSettingsForm-exportSectionGridSub-qcYQr`,
	"exportText": `BannerSettingsForm-exportText-kjz_0`,
	"exportLinkImg": `BannerSettingsForm-exportLinkImg-cAwpD`,
	"exportImg": `BannerSettingsForm-exportImg-iohfj`,
	"linkBtn": `BannerSettingsForm-linkBtn-Kw1jq`,
	"table": `BannerSettingsForm-table-xC8gL`,
	"tableRow": `BannerSettingsForm-tableRow-mrKyj`,
	"tableCell": `BannerSettingsForm-tableCell-t4BrN`,
	"formGroup": `BannerSettingsForm-formGroup-yrOBV`,
	"marginTop0": `BannerSettingsForm-marginTop0-KAYRl`,
	"marginBottom20": `BannerSettingsForm-marginBottom20-uDhZR`,
	"bannerImageBg": `BannerSettingsForm-bannerImageBg-Kf7wA`,
	"bannerDelete": `BannerSettingsForm-bannerDelete-LBxwd`,
	"exportLink": `BannerSettingsForm-exportLink-jANOr`,
	"seachContent": `BannerSettingsForm-seachContent-Av1HO`,
	"marginBottom9": `BannerSettingsForm-marginBottom9-f5iRm`,
	"spaceTop52": `BannerSettingsForm-spaceTop52-QjFfm`,
	"profileViewInner": `BannerSettingsForm-profileViewInner-KNW5v`,
	"profileViewMain": `BannerSettingsForm-profileViewMain-GGLoA`,
	"profileViewlabel": `BannerSettingsForm-profileViewlabel-vMdGa`,
	"profileViewMainContent": `BannerSettingsForm-profileViewMainContent-BtwS0`,
	"reviewsFormStar": `BannerSettingsForm-reviewsFormStar-Jw0ko`,
	"addLanguageText": `BannerSettingsForm-addLanguageText-c0VIP`
};
module.exports = ___CSS_LOADER_EXPORT___;
